export default __webpack_public_path__ + "static/media/Minor Brew of Aptitude.3682c25f.jpg";